/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_StepInputs */

const en_reports_col_step = /** @type {(inputs: Reports_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stage`)
};

const pt_br2_reports_col_step = /** @type {(inputs: Reports_Col_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etapa`)
};

/**
* | output |
* | --- |
* | "Stage" |
*
* @param {Reports_Col_StepInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_col_step = /** @type {((inputs?: Reports_Col_StepInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_StepInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_step(inputs)
	return pt_br2_reports_col_step(inputs)
});